import { Component, OnInit, isDevMode } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-credit-rating',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['./credit-rating.component.scss', '../../step/step.component.scss','../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CreditRatingComponent extends ButtonStepComponent implements OnInit {

  title: string = "Estimate your credit score";
  buttonList = [
      { text: 'Excellent', info:'680 or above', value: 'Excellent', imageName: 'excellent', className: ''},
      { text: 'Good ', info:'620 - 679', value: 'Good', imageName: 'good', default: true },
      { text: 'Fair ', info:'550 - 619', value: 'Fair', imageName: 'fair' },
      { text: 'Poor', info:'549 or below', value: 'Poor', imageName: 'poor' },
      { text: 'Don\'t Know', value: 'Unknown', imageName: 'dont-know' }
    ];

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('creditRating', this.control);

    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        if (variationData.enabledVariations.hasOwnProperty('creditRateBtn2')) {
          this.buttonList = [
            { text: 'Excellent - Very Good', info:'Above 680', value: 'Excellent', imageName: 'excellent', className: 's-125 text-max-w-110'},
            { text: 'Good - Average', info:'679 - 620', value: 'Good', imageName: 'good', className: 's-125 ab-fix text-max-w-110'},
            { text: 'Fair ', info:'619 - 550', value: 'Fair', imageName: 'fair', className: 's-125' },
            { text: 'Poor', info:'549 or below', value: 'Poor', imageName: 'poor', className: 's-125' },
            { text: 'Don\'t Know', info: '', value: 'Unknown', imageName: 'dont-know', className: 's-125' }
          ];
        }
      }
    );
  }

  shouldRedirectToOffers(value: string): boolean {
    // FRU Local leads allowed to continue with "poor" credit
    if (this.form.controls.leadReferrer.value.source == 'FRULocal') {
      return false;
    }

    this.buttonList[1].default = false;

    return value === 'Poor';
  }

  redirectTables(value: string): boolean {

    /* Redirect fair credit on purchase leads
    Redirect removed - FRU-12246
    if (this.form.controls.type.value === 'purchase' && value === 'Fair') {
      if (isDevMode()) {
        console.log('purchase fair credit redirect');
      }
      return true;
    }
    */
    

    /* 
    Redirect fair credit if the lead will be LL. Will only run for refi since purchase is already out on fair
    if (value === 'Fair' && this.form.controls.desiredLoanAmount.value <= 99000) {
      if (isDevMode()) {
        console.log('fair credit LL redirect');
      }
      return true;
    }
    */

    // Redirect fair credit if LTV > 80. Will only run for refi since purchase is already out on fair
    // if (value === 'Fair' && this.form.controls.ltv.value > 80) {
    //   if (isDevMode()) {
    //     console.log('fair credit ltv > 80 redirect');
    //   }
    //   return true;
    // }

    return false;
  }

}
